import React, { useEffect } from "react";
import Aos from 'aos';
import
{
    Grid,
    Container,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const stylesFunc = makeStyles( ( theme ) => ( {
    wrapper: {
        marginTop: "3rem",
        height: "calc(200vh - 19.0625rem)",
        // textAlign: 'start',
        marginBottom: "30rem",

    },
    header: {
        display: 'flex',
        marginBottom: "3rem",
        alignItems: 'center',
        justifyContent: 'space-evenly'

    },

    documentItem: {
        textDecoration: 'none',
        color: "#34455E",
        alignSelf: 'center'
    },

    documentLine: {
        textAlign: 'start',
    },
    icon: {
        textAlign: 'end',
    },
    formHeader: {
        textAlign: 'center',
        marginBottom: '1rem',
        marginTop: '1rem',
        color: "#34455E",
    },
    submitButton: {
        marginBottom: '1em',
        background: '#14688D',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#fff',
            color: '#14688D'
        }
    },
    formStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '2rem'

    },
    videoContainer: {
        position: 'relative',
        width: '100%',
        height: '0',
        paddingBottom: '56.25%',
        marginBottom:'5rem' 
    },
    iFrame: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',

    },

    wholeBlock:{
        marginBottom: "10rem"
    }
}
) );

const Youth = () =>
{

    const formStyles = stylesFunc();
    useEffect( () =>
    {
        Aos.init( { duration: 3000 } );
    }, [] );

    Aos.refresh()

    return (

        <Container className={ formStyles.wrapper } maxWidth='md'className={ formStyles.wholeBlock }>
                 <div><br></br></div>
                 <div><br></br></div>
                 <div><br></br></div>
            
            <Grid container spacing={ 2 } >
                <Grid data-aos="fade-right" item xs={ 2 } sm={ 2 } md={ 2 } className={ formStyles.header } >
                    <i className="fas fa-seedling fa-4x" style={ { color: "#14688D" } }></i>
                </Grid>
                <Grid data-aos="fade-left" item xs={ 10 } sm={ 10 } md={ 10 }>
                    <Typography className={ formStyles.formHeader } variant="h4">
                    Youth Engagement Documents
                </Typography>
                </Grid>
                <Grid data-aos="fade-up" className={ formStyles.formStyle } container spacing={ 3 }>
                    <Grid item xs={ 2 } sm={ 2 } md={ 2 } className={ formStyles.icon } >
                        <a href="/documents/unyouth2030.pdf" target="_blank"><i className="far fa-file-pdf fa-3x" style={ { color: "#14688D" } } ></i></a>
                    </Grid>
                    <Grid item xs={ 10 } sm={ 10 } md={ 10 } className={ formStyles.documentLine }>
                        <Typography variant="subtitle1">
                            <a className={ formStyles.documentItem } href="/documents/unyouth2030.pdf" target="_blank">Youth2030 Global Progress Report</a>
                        </Typography>
                    </Grid>
                </Grid>
               
                </Grid>
                <br></br>
                
                
                
                
                
                
                
        </Container>
    );
}

export default Youth;
